<template>
  <Modal 
    :id="'cmp-add-licenceAccounts'"
    @cancelled="onCancel"
  >
   
      <template slot="header"></template>

    <template slot="body">
        <div style="border:1px solid var(--sprt-85)">
          <DBoxTextarea
            :yellowStyle="false"
            :id="'cmp-labelcopy'"            
            :value="tracksList"
                    
          />
        </div>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">Close</button>
        <button class="dt-button v1 s6" @click="onOKClick">Send Mail</button>
        
    
 
      
    </template>
  </Modal>
</template>

<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';


import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';

import { licenceService } from '../../services/licence.service';

import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import { sendMailHref } from "../../../../utility";



export default {
  props: {


  },
  components: {
    InputField,
    DBoxTextarea,
    Modal
  },
  mixins: [
 
  ],

  data: function() {
    return {
      tracksList:[]
    };
  },
  mounted:async function() {
      console.log(":::::",this.$route.query.licence_id)
      const resData=await licenceService.labelcopyTracks(this.$route.query.licence_id);
      console.log("::::",resData)
      this.tracksList=resData.data.preview;

  },
  computed: {
    tracksListString:function(){
      if(this.tracksList.length>0){
        return this.tracksList.reduce((accum,cur)=>{

          const versionLengthFlag = cur['version'] && cur['version'].length>0;
          console.log(versionLengthFlag,":versionLengthFlag:");
          const artistString=`Artist: ${cur['artist']||''}\n`;
          const titleString=versionLengthFlag?`Title: ${cur['title']} (${cur['version']})\n`:`Title: ${cur['title']||''}\n`;
          const versionString=`Version: ${cur['version']||''}\n`;
          const playTimeString=`Playtime: ${cur['playtime']||''}\n`;
          const explicitLyricsString=`Explicit Lyrics: ${(cur['explicit_flag']?'Yes':'No')||''}\n`;
          const isrcString=`ISRC: ${cur['isrc']||''}\n`;
          const pString=`(P): ${cur['p_year']||''}${cur['p_line']||''}\n`; 
          const countryString=`Country: ${cur['country']||''}\n\n`; 
          const composersString=`Composers: ${cur['composers'].length>0?cur['composers'][0]['name']:''}\n`;
          const writersString=`Writers: ${cur['writers'].length>0?cur['writers'][0]['name']:''}\n`;
          const producersString=`Producers: ${cur['producers'].length>0?cur['producers'][0]['name']:''}\n`;
          const publishersString=`Publishers: ${cur['publishers'].length>0?cur['publishers'][0]['name']:''}\n\n`;


          const additionalsString=cur['additionals'].reduce((acc,cu)=>{
              return acc+=`${cu['description']} :${cu['name']}\n`
          },"");
          const endDetails="----------------------------------------------------------\n"
          return accum+=artistString+titleString+versionString+playTimeString+explicitLyricsString+isrcString+pString+countryString+composersString+writersString+producersString+publishersString+additionalsString+endDetails
          
        },"");
      }
      return "";
    }
  },
  methods: {
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },
    onOKClick:function(){
      sendMailHref({subject:'',body:this.tracksList,mails:[]});
    }

  }

};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>